import React from "react";
import NumberFormat from "react-number-format";

interface DecimalNumberFormatProps {
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  decimalScale?: number;
  // Off by default: most consumers (Liability, Gross Premium, etc.) are
  // never negative. Set true for fields that legitimately can be (e.g.
  // ReceiptAmount, which is negative for credits).
  allowNegative?: boolean;
  [key: string]: any;
}

// Amount-style masked input for grid header searches. Emits the RAW numeric
// string (values.value, e.g. "1250.56") rather than the formatted display value,
// so the filter reaches the API's `decimal?` criteria fields unmangled.
const DecimalNumberFormat = ({
  inputRef,
  onChange,
  name,
  decimalScale = 2,
  allowNegative = false,
  ...rest
}: DecimalNumberFormatProps) => (
  <NumberFormat
    {...rest}
    getInputRef={inputRef}
    onValueChange={(values: any) => {
      onChange({ target: { name, value: values.value } });
    }}
    thousandSeparator=","
    decimalSeparator="."
    decimalScale={decimalScale}
    isNumericString
    // No fixedDecimalScale: a search box should not force a ".00" tail
    // while the user is still typing.
    allowNegative={allowNegative}
    name={name}
  />
);

export default DecimalNumberFormat;
